const semRoldana = [
  'Movimento suave e silencioso',
  'Sem desgaste mecânico — maior durabilidade',
  'Design minimalista e elegante',
  'Menos manutenção ao longo dos anos',
  'Aprovado em condomínios de alto padrão',
];

const comRoldana = [
  'Ruído ao abrir e fechar',
  'Desgaste das roldanas com o uso',
  'Aparência industrial e menos refinada',
  'Manutenção periódica obrigatória',
  'Pode ser reprovado em condomínios premium',
];

export default function Comparativo() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-bold tracking-widest text-amber-600 uppercase mb-3">
            COMPARATIVO
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-3">
            Sem Roldana × Com Roldana
          </h2>
          <p className="text-stone-500 text-sm max-w-lg mx-auto">
            Entenda por que o sistema articulado sem roldana é a melhor escolha para o seu imóvel.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Sem Roldana */}
          <div className="bg-stone-900 rounded-2xl p-7">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-award-fill text-amber-400 text-base"></i>
              </div>
              <span className="text-amber-400 text-xs font-bold uppercase tracking-widest">Padrão Thelux</span>
            </div>
            <h3 className="text-white text-xl font-bold mb-5">Articulado Sem Roldana</h3>
            <ul className="space-y-3">
              {semRoldana.map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-white/85 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-green-400 text-sm"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
            <div className="mt-6 bg-amber-500/15 border border-amber-500/25 rounded-lg px-4 py-2.5 text-center">
              <span className="text-amber-400 text-xs font-semibold">RECOMENDADO</span>
            </div>
          </div>

          {/* Com Roldana */}
          <div className="bg-stone-100 rounded-2xl p-7">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-error-warning-line text-stone-400 text-base"></i>
              </div>
              <span className="text-stone-400 text-xs font-bold uppercase tracking-widest">Sistema Genérico</span>
            </div>
            <h3 className="text-stone-700 text-xl font-bold mb-5">Convencional Com Roldana</h3>
            <ul className="space-y-3">
              {comRoldana.map((item) => (
                <li key={item} className="flex items-start gap-2.5 text-stone-500 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-close-circle-fill text-red-400 text-sm"></i>
                  </div>
                  {item}
                </li>
              ))}
            </ul>
            <div className="mt-6 bg-red-50 border border-red-200 rounded-lg px-4 py-2.5 text-center">
              <span className="text-red-400 text-xs font-semibold">NÃO RECOMENDADO</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}